import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({ name: 'daysPipe'})
export class DaysPipe implements PipeTransform  {

  constructor(private sanitized: DomSanitizer) {}
  transform(value) {
    return this.declOfNum(value);
  }

  declOfNum(n) {
    let dict = ['день', 'дня', 'дней'];
    return dict[(n % 10 === 1 && n % 100 !== 11) ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2];
  }

}



// WEBPACK FOOTER //
// ./src/app/pipes/days.pipe.ts